import React, { useState } from 'react';
import { FaDatabase, FaTable, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import ParticleBackground from '../common/ParticleBackground';

const ExerciseHeader = ({ title, scenario, introduction, tables = [] }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-primary-dark to-primary px-6 py-8">
      <ParticleBackground particleCount={35} maxDist={95} speed={0.18} />
      <div className="relative z-10 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-6 items-start">
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight">{title}</h2>
            <p className="mt-4 text-gray-200 text-lg leading-relaxed prose prose-sm max-w-none whitespace-pre-line">{scenario}</p>
          </div>

          {tables && tables.length > 0 && (
            <aside className="w-full lg:w-64 flex-shrink-0">
              <div className="bg-white/10 border border-white/20 rounded-lg p-4 backdrop-blur-sm">
                <div className="flex items-center gap-3 mb-3">
                  <FaDatabase className="text-white text-xl" />
                  <div>
                    <div className="text-sm text-white/90 font-semibold">Datasets</div>
                    <div className="text-xs text-white/80">Available for this case</div>
                  </div>
                </div>

                <div className="hidden lg:block space-y-2">
                  {tables.map((t) => (
                    <div key={t.name} className="flex items-center gap-3 bg-white/5 rounded-md p-2" title={t.desc}>
                      <FaTable className="text-white/90" />
                      <div className="text-sm">
                        <div className="font-medium text-white">{t.name}</div>
                        {t.desc && <div className="text-xs text-white/80">{t.desc}</div>}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="lg:hidden">
                  <button onClick={() => setOpen(o => !o)} className="w-full flex items-center justify-between px-3 py-2 bg-white/5 rounded">
                    <div className="flex items-center gap-3">
                      <FaTable className="text-white/90" />
                      <div className="text-sm text-white">Tables</div>
                    </div>
                    {open ? <FaChevronUp /> : <FaChevronDown />}
                  </button>

                  {open && (
                    <div className="mt-3 space-y-2">
                      {tables.map((t) => (
                        <div key={t.name} className="flex items-center gap-3 bg-white/5 rounded-md p-2" title={t.desc}>
                          <FaTable className="text-white/90" />
                          <div className="text-sm text-white">{t.name}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </aside>
          )}
        </div>

        {introduction && (
          <div className="mt-6">
            <div className="bg-white rounded-lg p-5 shadow-md border border-gray-100">
              <div className="text-gray-800 text-sm leading-relaxed">{introduction}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExerciseHeader;
